import React, { useState } from "react";
import FormatDateTime from "../../utils/formatDateTime";
import { ChevronsUpDownIcon } from "lucide-react";

const SourceTagsTableData = ({ data }) => {
  const today = new Date();
  const todayDateString = today.toISOString().split("T")[0];

  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const filteredSortedData =
    data &&
    data
      ?.filter((item) => item.date.startsWith(todayDateString))
      ?.sort((a, b) => new Date(b.date) - new Date(a.date)); 

  // console.log("filtered data",filteredSortedData);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const sortedData = [...filteredSortedData]?.sort((a, b) => {
    if (!sortField) return 0;
    const aValue = a[sortField];
    const bValue = b[sortField];

    if (aValue < bValue) return sortOrder === "asc" ? -1 : 1;
    if (aValue > bValue) return sortOrder === "asc" ? 1 : -1;
    return 0;
  });

  return (
    <div className="z-0 w-full font-poppins h-[calc(100vh-60px)] border-t-[1px] border-gray-800 custom-scroll overflow-x-auto shadow-md animate-reveal transition-all duration-500 ease-in">
      <table className="bg-black text-sm w-full relative z-0">
        <thead className="sticky top-0 bg-[#0F0F0F] text-sm text-left">
          <tr className="text-white border-b border-gray-800">
            <th
              className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold"
              scope="col"
            >
              S.No
            </th>
            <th
              className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold"
              scope="col"
            >
              Date Time
            </th>
            <th
              className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold"
              scope="col"
            >
              Symbol
              <ChevronsUpDownIcon
                onClick={() => handleSort("symbol")}
                className="h-4 w-4 text-white cursor-pointer inline-block ml-1"
              />
            </th>
            <th
              className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold"
              scope="col"
            >
              Sources
              <ChevronsUpDownIcon
                onClick={() => handleSort("sources")}
                className="h-4 w-4 text-white cursor-pointer inline-block ml-1"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {data && filteredSortedData.length > 0 ? (
            sortedData
              // .sort((a, b) => new Date(b.date) - new Date(a.date))
              .map((ele, i) => (
                <tr key={i} className="text-white border-b border-gray-800 ">
                  <td className="px-4 py-3 border-r last-of-type:border-r-0 border-gray-900 text-white">
                    {i + 1}
                  </td>
                  <td className="px-4 py-3 border-r last-of-type:border-r-0 border-gray-900 text-white">
                    {FormatDateTime(ele.date)}
                  </td>
                  <td className="px-4 py-3 border-r last-of-type:border-r-0 border-gray-900 text-white">
                    {ele.symbol}
                  </td>
                  <td className="px-4 py-3 border-r last-of-type:border-r-0 border-gray-900 text-white">
                    <div className="w-full space-x-2">
                      {ele.sources.map((source, index) => (
                        <span
                          key={index}
                          className={`${
                            source === "External"
                              ? "bg-orange-600"
                              : "bg-gray-600"
                          }  text-white text-sm px-2 py-1 rounded-[4px]`}
                        >
                          {source}
                        </span>
                      ))}
                    </div>
                  </td>
                </tr>
              ))
          ) : (
            <tr>
              <td
                colSpan="4"
                rowSpan="20"
                className="px-4 py-20 text-center text-white text-[20px] font-medium"
              >
                No Data Available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SourceTagsTableData;
